module.exports = __webpack_public_path__ + "img/close.7e851c45.svg";